export class ScrollTo{
	init(){
		$('.scroll-to a').on('click', function(e){
			e.preventDefault();
			var distElement 		= $(this).attr('href'),
					distElementTop 	= $(distElement).offset().top - 15;
			
			$('html, body').animate({
				scrollTop: distElementTop
			}, 500);
		});


		$('.design-row a').click(function(e) {
			e.preventDefault();

			$(this).closest('.row').removeClass('above').addClass('under');
			$('.soul-red-row').addClass('above').removeClass('under');
		});

		$('.soul-red-row a').click(function(e) {
			e.preventDefault();

			$(this).closest('.row').removeClass('above').addClass('under');
			$('.design-row').addClass('above').removeClass('under');
		});
	}
}